import { render } from "./radio.html?vue&type=template&id=77a7bf53&scoped=true&external"
import script from "./radio.ts?vue&type=script&lang=js&external"
export * from "./radio.ts?vue&type=script&lang=js&external"

import "./radio.scss?vue&type=style&index=0&id=77a7bf53&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a7bf53"],['__file',"src/components/ui/radio/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77a7bf53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77a7bf53', __exports__)) {
    api.reload('77a7bf53', __exports__)
  }
  
  module.hot.accept("./radio.html?vue&type=template&id=77a7bf53&scoped=true&external", () => {
    api.rerender('77a7bf53', render)
  })

}


export default __exports__